import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { DatapointOptions } from 'owa-analytics-actions';
import { trackWorkflow } from 'mini-app-context/lib/utils/workflowUtils';

import {
    RSVP_EVENT_CLICKED,
    RSVP_EVENT_COMPLETE,
    RSVP_EVENT_SEND,
    RSVP_OVERLAY_CLICKED,
    DELETE_OR_CANCEL_EVENT_CLICKED,
    DELETE_OR_CANCEL_EVENT_CONFIRM_CLICKED,
    DELETE_OR_CANCEL_EVENT_COMPLETE,
    VIEW_BUTTON_CLICKED,
    EVENT_READING_PANE_LOADED,
    EVENT_CAPTURE_DISCARDED,
    EVENT_EDIT_CLICKED,
    SAVE_CAL_EVENT,
} from 'data/lib/mini-app-constants/commonEventSignalConstants';

let workflowAddedYet = false;

export const workFlowTrackerForRsvp = () => {
    if (!workflowAddedYet) {
        trackWorkflow<DatapointOptions>([
            {
                name: 'WF_meetingMessageAction',
                start: RSVP_EVENT_CLICKED,
                checkmarks: [RSVP_EVENT_SEND],
                end: [RSVP_EVENT_COMPLETE, RSVP_OVERLAY_CLICKED],
                options: { isCore: true },
            },
            {
                name: 'WF_RemoveMeetingInvite',
                start: DELETE_OR_CANCEL_EVENT_CLICKED,
                checkmarks: [DELETE_OR_CANCEL_EVENT_CONFIRM_CLICKED],
                end: [DELETE_OR_CANCEL_EVENT_COMPLETE],
                options: { isCore: true },
            },
            {
                start: VIEW_BUTTON_CLICKED,
                end: [EVENT_READING_PANE_LOADED],
                name: 'ViewCalendarEvent',
                options: { isCore: true },
            },
            {
                start: EVENT_EDIT_CLICKED,
                end: [SAVE_CAL_EVENT, EVENT_CAPTURE_DISCARDED],
                name: 'EditEvent',
                options: { isCore: true, timeout: TimeConstants.MillisecondsInOneDay },
            },
        ]);
        workflowAddedYet = true;
    }
};
